import { ReactElement, useEffect, useState } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { WebRosterScreen } from './WebRosterScreen'
import { MobileRosterScreen } from './MobileRosterScreen'
import { useNavigate } from 'react-router-dom'
import { useRosterStore, WrestlerData } from '../../stores/RosterStore'
import { SpinnerWrapper } from '../../components/spinner/SpinnerWrapper'

export interface RosterScreenData {
  fightbackChampion: WrestlerData | undefined
  collectorChampion: WrestlerData | undefined
  tagTeamChampions: WrestlerData[] | undefined
  collectors: WrestlerData[] | undefined
  wrestlers: WrestlerData[] | undefined
  officials: WrestlerData[] | undefined
  onWrestlerClick: (wrestler: WrestlerData) => void
}

export interface WrestlerDetailViewData {
  wrestler: WrestlerData
  onBackClick: () => void
}

export const RosterScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)
  const navigate = useNavigate()
  const rosterStore = useRosterStore()
  const [rosterScreenData, setRosterScreenData] = useState<RosterScreenData>()

  const onWrestlerClick = (wrestler: WrestlerData): void => {
    navigate(wrestler.slug)
  }

  useEffect(() => {
    if (rosterStore.loaded) {
      setRosterScreenData({
        wrestlers: rosterStore.wrestlers,
        fightbackChampion: rosterStore.fightbackChampion,
        collectorChampion: rosterStore.collectorChampion,
        tagTeamChampions: rosterStore.tagTeamChampions,
        collectors: rosterStore.collectors,
        officials: rosterStore.officials,
        onWrestlerClick: onWrestlerClick,
      })
    }
  }, [rosterStore])

  return (
    <SpinnerWrapper loaded={rosterStore.loaded} isMobile={isMobile}>
      {rosterScreenData === undefined ? (
        <></>
      ) : isMobile ? (
        <MobileRosterScreen data={rosterScreenData} />
      ) : (
        <WebRosterScreen data={rosterScreenData} />
      )}
    </SpinnerWrapper>
  )
}
